import bootstrap from './bootstrap'

// 3rd Parties
import chart from './chart'
// import highlight from './highlight'
import feather from './feather'
import slick from './slick'
import tooltipster from './tooltipster'
import datatable from './datatable'
import datepicker from './datepicker'
import select2 from './select2'
// import dropzone from './dropzone'
//import summernote from './summernote'
import validation from './validation'
// import imageZoom from './image-zoom'
// import svgLoader from './svg-loader'
import toast from './toast'

// Components
// import maps from './maps'
// import chat from './chat'
import dropdown from './dropdown'
import modal from './modal'
import showModal from './show-modal'
import tab from './tab'
import accordion from './accordion'
import search from './search'
// import copyCode from './copy-code'
// import showCode from './show-code'
import sideMenu from './side-menu'
import mobileMenu from './mobile-menu'
import sideMenuTooltip from './side-menu-tooltip'

//VUE
import LoginComponent from './components/login/Login'
import ResetPasswordComponent from './components/login/ResetPassword'
import RolManagementComponent from './components/roles/RolManagementComponent';
import MaterializableComponent from './components/MaterializableComponent';
import MonthPicker from 'vue-month-picker';

import AnimatedIcon from './components/AnimatedIcon'
import VueAxiosConfig from "./vue/axios";
import VueHelperConfig from "./vue/helper";


Vue.component('login-component', LoginComponent);
Vue.component('reset-password-component', ResetPasswordComponent);
Vue.component('rol-management-component', RolManagementComponent);
Vue.component('materializable-component', MaterializableComponent);
Vue.component('animated-icon',AnimatedIcon);

Vue.use(MonthPicker);
Vue.use(VueAxiosConfig);
Vue.use(VueHelperConfig);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

window.app = new Vue({
    el: '#app',
});
